import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Select,
  Text,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Image,
} from "@chakra-ui/react";
import defaultImage from "../../assets/img/userimage.jpg";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { IoMdClose } from "react-icons/io";
import { use } from "react";

const QuickBillPrintModal = ({
  isOpen,
  onClose,
  customerId,
  onOpen,
  foodBillData,
}) => {
  // console.log(data,'data')
  const [printData, setPrintData] = useState([]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getPrintData/${customerId}`,
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.hotel.launchlysoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              },
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        }),
      );

      console.log(updatedRooms, "updatedRooms");
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData3();
  }, [customerId]);
  const print = () => {
    handlePrint();
  };
  const handleClose = () => {
    onClose();
  };
  const scroll = "inside";

  return (
    <Modal
      width="full"
      size="7xl"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      scrollBehavior={scroll}
    >
      <ModalOverlay />
      <ModalContent bg="#f9f1e3">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          {/* <Text>RoomBook Data- {roomBookData?.name}</Text> */}
          <Button colorScheme="red" onClick={handleClose}>
            <IoMdClose />
          </Button>
        </ModalHeader>
        <ModalBody>
          {foodBillData ? (
            <Card
              mt={10}
              textAlign="center"
              boxShadow="dark-lg"
              ref={componentRef}
              width="794px"
              mx="auto"
            >
              <Text
                color="purple"
                fontSize="18px"
                fontFamily="sans-serif"
                mt={5}
              >
                QuickBill Data Report
              </Text>
              <CardHeader
                display="flex"
                justifyContent="center"
                flexDirection="column"
                alignItems="center"
                gap={5}
                p={4}
                boxShadow="md"
              >
                <Box
                  color="purple"
                  fontSize="18px"
                  fontFamily="sans-serif"
                  textAlign="center"
                >
                  {printData.map((item) => (
                    <>
                      <Image
                        alignItems="center"
                        src={item.imageUrl}
                        w="220px"
                        h="100px"
                        mb={2}
                      />
                      <Text>{item.name}</Text>
                      <Text fontSize="10px">{item.adress}</Text>
                      <Text fontSize="10px">{item.phoneNo}</Text>
                      <Text fontSize="10px">{item.website}</Text>
                      <Text fontSize="10px">Email id:{item.email}</Text>
                      <Text fontSize="10px">Gst No:{item.gstNo}</Text>
                    </>
                  ))}
                </Box>
              </CardHeader>
              <CardBody
                display="flex"
                justifyContent="space-between"
                p={1}
                textAlign="left"
              >
                <TableContainer width="full">
                  <Table size="sm" variant="striped" colorScheme="green">
                    <TableCaption>Quick Bill Data</TableCaption>
                    <Thead>
                      <Tr>
                        <Th fontSize="8px">Food Item</Th>
                        <Th fontSize="8px">Name</Th>
                        <Th fontSize="8px">Phone No</Th>
                        <Th fontSize="8px">Bill No</Th>
                        <Th fontSize="8px">Total Bill</Th>
                        <Th fontSize="8px">Status</Th>
                        <Th fontSize="8px">Created At</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {foodBillData.map((order, index) => (
                        <Tr key={index}>
                          <Td fontSize="8px">
                            {order.foodItem.map((item) => item.name).join(", ")}
                          </Td>
                          <Td fontSize="8px">{order.name}</Td>
                          <Td fontSize="8px">{order.phoneNo}</Td>
                          <Td fontSize="8px">{order.billNo}</Td>
                          <Td fontSize="8px">{order.totalBilling}</Td>
                          <Td fontSize="8px">
                            {order.status ? "Due" : "Paid"}
                          </Td>
                          <Td fontSize="8px">
                            {new Date(order.createdAt).toLocaleString("en-GB")}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </CardBody>
            </Card>
          ) : (
            ""
          )}

          <Box
            display="flex"
            flexDirection="row"
            justifyContent="end"
            alignItems="center"
            gap="3"
          >
            <Button as="b" colorScheme="blue" onClick={print}>
              Print
            </Button>
            <Button as="b" colorScheme="blue" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default QuickBillPrintModal;
